import _ from 'lodash';
import { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { getTranslatedKey, getTranslationByKey } from '../actions/TranslationActions';

export const cacheRef = new Set();

export const useTranslation = () => {
  const translations = useSelector((state) => state.translations, shallowEqual);
  const dispatch = useDispatch();

  const translateString = useCallback(
    (key) => {
      if (!key && !_.isNumber(key)) {
        return '';
      }

      if (!translations?.system) {
        return key;
      }

      const translatedKey = getTranslationByKey(key, translations);

      if (_.isNil(translatedKey)) {
        if (!cacheRef?.has(key)) {
          cacheRef.add(key);
          dispatch(getTranslatedKey(key));
        }
        return key;
      }

      return translatedKey;
    },
    [translations, dispatch]
  );

  return translateString;
};
